import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import MainButton from '../MUI/MainButton';
import useStyles from './makeStyles';

const SuggestedPersons = (props) => {
  const { contractType, suggestedList, memberList, onAdd, onRemove } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const finalList = suggestedList.map((person) => {
    const alreadyAdded = memberList.find((member) => member.passport === person.passport);

    let handler;
    if (alreadyAdded) {
      handler = () => onRemove(alreadyAdded);
    } else {
      handler = onAdd;
    }
    return (
      <MainButton
        color="primary"
        key={person.passport}
        className={classNames(classes.mainButton, {
          [classes.active]: alreadyAdded,
        })}
        variant={alreadyAdded ? 'contained' : 'outlined'}
        onClick={() => handler(person)}
      >
        <span>{`${person.firstName} ${person.lastName}`}</span>
      </MainButton>
    );
  });

  if (suggestedList.length === 0) {
    return null;
  }

  return (
    <div className={classes.suggestedPersons}>
      <p className={classes.title}>{t(`${contractType}.suggestedPersons`)}</p>
      <p className={classes.description}>{t(`${contractType}.suggestedPersonsText`)}</p>
      <div className={classes.personButtonContainer}>{finalList}</div>
    </div>
  );
};

const userPropType = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  passport: PropTypes.string,
});

SuggestedPersons.propTypes = {
  contractType: PropTypes.string.isRequired,
  suggestedList: PropTypes.arrayOf(userPropType).isRequired,
  memberList: PropTypes.arrayOf(userPropType).isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

SuggestedPersons.defaultProps = {
  onAdd: () => {},
  onRemove: () => {},
};

export default SuggestedPersons;
